export default {
  setLoadingLogList(state, loadingLogList) {
    state.loadingLogList = loadingLogList;
  },
  setCTeLogList(state, cteLogList) {
    state.cteLogList = cteLogList;
  },
  setCTeLogListTotal(state, cteLogListTotal) {
    state.cteLogListTotal = cteLogListTotal;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/cte-logs/store/mutations.js